import { render, staticRenderFns } from "./ShuttleRegisterDetails.vue?vue&type=template&id=2c44243a&scoped=true&"
import script from "./ShuttleRegisterDetails.vue?vue&type=script&lang=js&"
export * from "./ShuttleRegisterDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleRegisterDetails.vue?vue&type=style&index=0&id=2c44243a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44243a",
  null
  
)

export default component.exports